/**
 * לקוח ה-API ליומן הפעולות — TASKS 3.6. לקריאה בלבד.
 */
import type { AdminApiError } from './adminApi.js';

export interface AuditLogEntry {
  id: number;
  actor: string;
  action: string;
  entity: string;
  entity_id: string | null;
  before_json: unknown;
  after_json: unknown;
  ip: string | null;
  created_at: string;
}

interface ListResult {
  entries: AuditLogEntry[];
  page: number;
  pageSize: number;
  total: number;
}

async function parseErrorBody(res: Response): Promise<AdminApiError> {
  try {
    const body = (await res.json()) as { error?: { code?: string; message?: string } };
    return {
      status: res.status,
      code: body.error?.code ?? 'UNKNOWN_ERROR',
      message: body.error?.message ?? 'אירעה שגיאה לא צפויה.',
    };
  } catch {
    return { status: res.status, code: 'UNKNOWN_ERROR', message: 'אירעה שגיאה לא צפויה.' };
  }
}

export async function listAuditLog(params: { page: number; entity?: string }): Promise<ListResult> {
  const query = new URLSearchParams({ page: String(params.page) });
  if (params.entity) query.set('entity', params.entity);

  const res = await fetch(`/api/admin/audit-log?${query.toString()}`, {
    credentials: 'same-origin',
  });
  if (!res.ok) throw await parseErrorBody(res);
  return (await res.json()) as ListResult;
}
